// extracted by mini-css-extract-plugin
export default {"legend":"map_legend__R5slT"};